import { render, staticRenderFns } from "./ccm-empresas.vue?vue&type=template&id=ad508f72&"
import script from "./ccm-empresas.vue?vue&type=script&lang=js&"
export * from "./ccm-empresas.vue?vue&type=script&lang=js&"
import style0 from "./ccm-empresas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports